export const motto = {
	PAGE_THEME_ENABLED: false,
};
